module.exports = __webpack_public_path__ + "static/media/american-football.e54401b6.svg";